import { MaterialUICore, axiomTokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const HeaderTitle = styled('span')({
  fontSize: axiomTokens.font.size.md,
  color: axiomTokens.color.typeface.pure,
  fontWeight: axiomTokens.font.weight.bold,
});
